export class PersonRefreshTokenLogin {
    constructor(refreshToken) {
        this.refreshToken = refreshToken;
    }
}